import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    zoom: 1,
    firefox: false
  },
  mutations: {
    zoomOut(state) {
      if (state.zoom > 0.2) {
        state.zoom -= 0.1
      }
    },
    zoomIn(state) {
      if (state.zoom < 1.8) {
        state.zoom += 0.1
      }
    },
    firefox(state) {
      state.firefox = true
    }
  },
  actions: {

  },
  getters: {
    zoom(state) {
      return state.zoom
    },
    firefox(state) {
      return state.firefox
    }
  }
})
